module.exports = __webpack_public_path__ + "img/qz5.0.cc08ecea.png";